import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-recurrence',
  templateUrl: './recurrence.component.html',
  styleUrls: ['./recurrence.component.scss']
})
export class RecurrenceComponent implements OnInit {
  @Input() recurrence: any;
  @Input() selected = false;

  @Output() select = new EventEmitter<any>();
  @Output() unselect = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {
  }

  toggleSelected() {
    this.selected = !this.selected;
    if (this.selected) {
      this.select.emit(this.recurrence);
    } else {
      this.unselect.emit(this.recurrence);
    }
  }

  get type() {
    return ["Empty", "Return", "Time", "Cycle", "On Demand"][this.recurrence.type || 0];
  }

  get unit() {
    return ["Empty", "Days", "Weeks", "Months"][this.recurrence.unit || 0];
  }
}
